// Removed unused UploadBox
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { rejectionFields } from "../../../descriptions/jewellery-inspector/inspectionRequests.description";
import useI18N from "../../../hooks/useI18N";
import MUIModal from "../../../shared/MUIModal";
import SABox from "../../../shared/SABox";
import SAButton from "../../../shared/SAButton";
import SAFormFields from "../../../shared/SAFormFields";
import SAStack from "../../../shared/SAStack";
import SATypography from "../../../shared/SATypography";

const ApproveRejectModal = ({
  open,
  onClose,
  onSend,
  loading = false,
  approveModalOpen,
  setApproveModalOpen,
  handleApprove,
  setRejectFiles = () => {},
}) => {
  const [imagePreviews, setImagePreviews] = useState([]);
  const { t } = useI18N();
  const form = useForm({
    mode: "onChange",
    defaultValues: { comment: "" },
  });
  const { register, control, handleSubmit, reset, formState } = form;

  // Remove single file logic, use rejectFiles for multiple
  const handleFileChange = (e) => {
    if (e.target.files) {
      const filesArray = Array.from(e.target.files);
      setRejectFiles(filesArray);
      const previews = filesArray.map((file) => URL.createObjectURL(file));
      setImagePreviews(previews);
    }
  };

  const handleRemoveImage = (idx) => {
    setRejectFiles((prev) => prev.filter((_, i) => i !== idx));
    setImagePreviews((prev) => prev.filter((_, i) => i !== idx));
  };

  const onSubmit = (data) => {
    if (onSend) onSend(data);
  };

  const handleCancel = () => {
    reset();
    if (onClose) onClose();
  };

  return (
    <>
      <MUIModal
        open={open}
        maxWidth={500}
        handleClose={handleCancel}
        content={
          <>
            <SABox sx={{ p: 3, display: "flex", flexDirection: "column" }}>
              <SATypography
                sx={{
                  color: "#444",
                  mb: 2,
                  fontSize: 22,
                  fontWeight: 600,
                }}
              >
                {t("rejection-reason")}
              </SATypography>
              <SATypography sx={{ color: "#444", mb: 2, fontSize: 13 }}>
                {t("rejection-reason-description")}
              </SATypography>
              <SAFormFields
                spacing={2}
                fields={rejectionFields}
                register={register}
                formState={formState}
                control={control}
              />
              <SATypography sx={{ fontSize: 15, mt: 2, mb: "5px" }}>
                {t("manufactured-design")}
              </SATypography>
              <SABox mb={2}>
                <SAButton variant="outlined" component="label" sx={{ mb: 1 }}>
                  <UploadFileIcon sx={{ mr: 2 }} />
                  {t("upload-design-sample")}
                  <input
                    type="file"
                    hidden
                    multiple
                    accept="image/*,application/pdf"
                    onChange={handleFileChange}
                  />
                </SAButton>
                <SAStack
                  direction="row"
                  spacing={1}
                  mt={2}
                  sx={{ overflowX: "auto", maxWidth: 550 }}
                >
                  {imagePreviews.map((src, idx) => (
                    <SABox
                      key={idx}
                      sx={{
                        width: 80,
                        height: 80,
                        borderRadius: 2,
                        overflow: "hidden",
                        border: "1px solid #e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        mr: 1,
                        flex: "0 0 auto",
                      }}
                    >
                      <img
                        src={src}
                        alt={`preview-${idx}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <SATypography
                        size="small"
                        sx={{
                          position: "absolute",
                          top: 2,
                          right: 2,
                          minWidth: 0,
                          width: 22,
                          height: 22,
                          borderRadius: "50%",
                          zIndex: 2,
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => handleRemoveImage(idx)}
                      >
                        <CloseOutlinedIcon fontSize="small" />
                      </SATypography>
                    </SABox>
                  ))}
                </SAStack>
              </SABox>
              <SABox
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  gap: 1,
                  mt: 2,
                  mb: 1,
                }}
              >
                <SAButton
                  variant="text"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  {t("cancel")}
                </SAButton>
                <SAButton
                  variant="contained"
                  color="primary"
                  loading={loading}
                  onClick={handleSubmit(onSubmit)}
                  disabled={loading}
                >
                  {t("send")}
                </SAButton>
              </SABox>
            </SABox>
          </>
        }
      />

      <MUIModal
        open={approveModalOpen}
        maxWidth={500}
        handleClose={() => setApproveModalOpen(false)}
        content={
          <SABox p={2}>
            <SATypography
              mb={2}
              fontWeight={500}
              fontSize={20}
              color="text.primary"
              sx={{ textAlign: "center" }}
            >
              {t("approve-confirmation")}
            </SATypography>
            <SAStack direction="row" gap={2} justifyContent="center">
              <SAButton
                onClick={() => setApproveModalOpen(false)}
                color="inherit"
              >
                {t("cancel")}
              </SAButton>
              <SAButton
                variant="contained"
                color="success"
                onClick={handleApprove}
                disabled={loading}
              >
                {t("confirm")}
              </SAButton>
            </SAStack>
          </SABox>
        }
      />
    </>
  );
};

export default ApproveRejectModal;
